import * as React from "react"
import AsyncMessageResponseHandler from "../AsyncMessageResponseHandler"
import SkeletonWrapper from "../SkeletonWrapper"

type AsyncMessageResponseHandlerProps = React.ComponentProps<
	typeof AsyncMessageResponseHandler
>
type SkeletonWrapperProps = React.ComponentProps<typeof SkeletonWrapper>
type RequestHandlerProps = AsyncMessageResponseHandlerProps &
	SkeletonWrapperProps

const RequestHandler: React.FC<RequestHandlerProps> = (props) => {
	const { children } = props

	return (
		<AsyncMessageResponseHandler {...props}>
			<SkeletonWrapper {...props}>{children}</SkeletonWrapper>
		</AsyncMessageResponseHandler>
	)
}

export default RequestHandler
